import api from '../../shared/api/client';
import { API_ROUTES } from '../../shared/api/routes';

export const authApi = {
  login: (credentials) => api.post(API_ROUTES.auth.login, credentials),
  getProfile: () => api.get(API_ROUTES.auth.profile),
  sendProfilePhoneOtp: (data) => api.post(API_ROUTES.auth.profilePhoneOtp, data),
  sendMfaOtp: () => api.post(API_ROUTES.auth.sendMfaOtp, {}),
  verifyMfaOtp: (otp) => api.post(API_ROUTES.auth.verifyMfaOtp, { otp }),
  getCapabilities: () => api.get(API_ROUTES.auth.capabilities),
  updateProfile: (data) => api.put(API_ROUTES.auth.profile, data),
  changePassword: (data) => api.post(API_ROUTES.auth.changePassword, data),
  forgotPassword: (data) => api.post(API_ROUTES.auth.forgotPassword, data),
  verifyEmailToken: (token) => api.post(API_ROUTES.auth.verifyEmail, { token }),
  verifyInviteToken: (token) => api.post(API_ROUTES.auth.verifyInvite, { token }),
  acceptInvite: (data) => api.post(API_ROUTES.auth.acceptInvite, data),
  verifyResetToken: (token) => api.post(API_ROUTES.auth.verifyResetPassword, { token }),
  resetPassword: (data) => api.post(API_ROUTES.auth.resetPassword, data),
  upsertAdminPushDevice: (deviceId, data) => api.put(API_ROUTES.auth.adminPushDevice(deviceId), data),
  deleteAdminPushDevice: (deviceId) => api.delete(API_ROUTES.auth.adminPushDevice(deviceId)),
};
